import { useState } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9qu0snnahb7382ovfug';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotVal = (formData.get('phone_alt') as string || '').trim();
    if (honeypotVal) {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const params = new URLSearchParams();
      formData.forEach((val, key) => {
        if (key !== 'phone_alt') {
          params.append(key, val as string);
        }
      });

      const res = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // not json
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg =
          (parsed?.meta as Record<string, string>)?.message ||
          (parsed?.meta as Record<string, string>)?.detail ||
          (parsed?.message as string) ||
          '订阅失败，请稍后重试';
        if (typeof msg === 'string' && (msg.includes('spam') || msg.includes('form data is spam'))) {
          setStatus('success');
          setEmail('');
          return;
        }
        setStatus('error');
        setErrorMsg(msg as string);
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-primary-500">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-white">
          订阅黄油推荐资讯
        </h2>
        <p className="mt-2 text-sm text-white/80">
          每周获取最新黄油评测、烘焙技巧和优惠信息
        </p>

        {status === 'success' ? (
          <div className="mt-6 flex items-center justify-center gap-2 text-white">
            <i className="ri-checkbox-circle-fill text-lg"></i>
            <span className="text-sm font-medium">订阅成功！感谢你的关注</span>
          </div>
        ) : (
          <form
            data-readdy-form
            onSubmit={handleSubmit}
            className="mt-6 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <div className="honeypot-wrapper">
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
            </div>
            <input
              type="email"
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              className="w-full sm:flex-1 px-4 py-2.5 rounded-full bg-white/20 text-white placeholder-white/60 border border-white/25 focus:outline-none focus:ring-2 focus:ring-white/40 text-sm backdrop-blur-sm"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-6 py-2.5 bg-white text-primary-600 font-medium text-sm rounded-full hover:bg-white/95 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {status === 'loading' ? '订阅中...' : '免费订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs text-white/80">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}